import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { VioTablesModule } from 'vio-tables';
import { FormsObjectType, VioInputModule, VioInputService } from 'vio-input';
import { CommonFunctionService } from '../../services/common-function.service';
@Component({
  selector: 'app-set-configuration-modal',
  standalone: true,
  imports: [FormsModule, CommonModule, NgbDropdownModule, NgbDatepickerModule, VioInputModule, VioTablesModule],
  templateUrl: './set-configuration-modal.component.html',
  styleUrl: './set-configuration-modal.component.scss'
})
export class SetConfigurationModalComponent implements OnInit {

  @Input() paramInfo: any = {};

  paramDetails: FormsObjectType = {
    config: {
      numberOfColumnsInRow: 1,
      formSubmitURL: '',
      isInvalidNoRequiredFieldSubmitted: false,
      showError: 'Inline',
      showLineBellowGroup: false,
      displayType: 'Floating',
    },
    fields: {
      idx: { dataType: 'number', inputType: 'number', groupName: '', groupHeading: '', isRequired: false, isReadOnly: true, isHidden: true, placeHolder: 'id', label: 'id', value: -1, marginPading: 'mt-1 mb-1', columnSize: 3, },
      param: { dataType: 'string', inputType: 'text', groupName: '', groupHeading: '', isRequired: true, isReadOnly: false, isHidden: false, placeHolder: 'Parameter Name', label: 'Parameter Name', value: '', marginPading: 'mt-1 mb-1', columnSize: 3, },
      key: { dataType: 'string', inputType: 'text', groupName: '', groupHeading: '', isRequired: true, isReadOnly: false, isHidden: false, placeHolder: 'Enter Key Name', label: 'Key Name', value: '', marginPading: 'mt-1 mb-1', columnSize: 3, },
      multFactor: { dataType: 'number', inputType: 'number', groupName: '', groupHeading: '', isRequired: true, isReadOnly: false, isHidden: false, placeHolder: 'Enter multiplication factor', label: 'Multiplication Factor', value: '', marginPading: 'mt-1 mb-1', columnSize: 3, },
      unit: { dataType: 'string', inputType: 'text', groupName: '', groupHeading: '', isRequired: true, isReadOnly: false, isHidden: false, placeHolder: 'Enter Unit', label: 'Unit', value: '', marginPading: 'mt-1 mb-1', columnSize: 3, },
    },
  };

  constructor(public ngbActiveModal: NgbActiveModal, private vioInputService: VioInputService, private common: CommonFunctionService) { }
  ngOnInit(): void {

    console.log('paramInfo = ', this.paramInfo)
    this.common.assignObjectValuesToVioInputComponent(this.paramDetails.fields, this.paramInfo);
  }

  addAndClose = () => {
    let result = this.vioInputService.generateKeyValuePairForFormObject(this.paramDetails.fields);
    console.log('Returning the new param result = ', result)
    this.closeModal(result);

  }

  closeModal(result: any) {
    this.ngbActiveModal.close(result);
  }
}
